"use strict";
var MinMaxConstraint = (function () {
    function MinMaxConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    return MinMaxConstraint;
}());
exports.MinMaxConstraint = MinMaxConstraint;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/models/min-max-constraint.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/models/min-max-constraint.model.js